import { StyleSheet } from 'react-native';

import {
  coral,
  neutralDark,
  neutralGrey,
  neutralLight,
  neutralWhite,
  warrior,
  white,
} from '../../../constants/color';

const styles: any = StyleSheet.create({
  billDetailSection: {
    width: '100%',
    backgroundColor: neutralWhite,
    borderColor: neutralLight,
    marginBottom: 10,
    marginTop: 20,
  },
  cartPageStyle: {
    marginBottom: 0,
    marginTop: 0,
  },
  lightGray: {
    color: neutralDark,
  },
  notSelected: {
    color: neutralGrey,
  },
  normalGray: {
    color: warrior,
  },
  normalFontStyle: {
    fontSize: 15,
    textAlign: 'center',
  },
  strongFontStyle: {
    color: coral,
    fontSize: 18,
    fontWeight: '700',
  },
  priceField: {
    flexDirection: 'row',
  },
  billDetail: {
    backgroundColor: white,
    paddingBottom: 10,
    paddingLeft: 15,
    paddingRight: 15,
    paddingTop: 2,
    width: '100%',
  },
  BillItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 8,
  },
  BillLabel: {
    alignItems: 'center',
    flexDirection: 'row',
  },
  labelMeta: {
    borderColor: coral,
    borderRadius: 12,
    borderWidth: 1,
    color: coral,
    fontSize: 12,
    lineHeight: 20,
    marginRight: 5,
    paddingLeft: 10,
    paddingRight: 10,
    textAlignVertical: 'center',
  },
  currencyHint: {
    textAlign: 'right',
    color: warrior,
    marginRight: -10,
  },
  iconQuestion: {
    marginLeft: 5,
  },
});

export default styles;
